import * as React from 'react';
import { Button } from 'antd';
import { getMicrosoftConfiguration, MicrosoftConfiguration } from 'app/services/api/microsoftAuth';
import { LoginLoading, LoginShell } from './components/LoginShell';

export function useMicrosoftConfiguration() {
  const [configuration, setConfiguration] = React.useState<MicrosoftConfiguration | null>(null);
  const [failed, setFailed] = React.useState(false);
  const [attempt, setAttempt] = React.useState(0);
  React.useEffect(() => {
    let active = true;
    setFailed(false);
    getMicrosoftConfiguration().then(
      value => {
        if (active) setConfiguration(value);
      },
      () => {
        if (active) setFailed(true);
      },
    );
    return () => {
      active = false;
    };
  }, [attempt]);
  return { configuration, failed, retry: () => setAttempt(value => value + 1) };
}

export function ConfigurationStatus({ failed, retry }: { failed: boolean; retry: () => void }) {
  return (
    <LoginShell variant={failed ? 'error' : 'loading'}>
      {failed ? (
        <div className="microsoft-login__content" role="alert">
          <h1 id="login-title" className="microsoft-login__result-title">
            Unable to load sign-in options
          </h1>
          <p className="microsoft-login__result-description">Please check your connection and try again.</p>
          <Button className="microsoft-login__primary-button" onClick={retry}>
            Try again
          </Button>
        </div>
      ) : (
        <LoginLoading title="Loading sign-in options…" hint="This may take a few seconds." />
      )}
    </LoginShell>
  );
}
